import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector) // ユーザーの言語設定を検知するために必要
  .init({
    fallbackLng: "ja", // デフォルトの言語を設定
    supportedLngs: ["en", "ja"], // 対応言語を日英に限定
    nonExplicitSupportedLngs: true, // "ja-JP" などを "ja" として扱う
    load: "languageOnly", // 地域コードを除いた言語コードで解決する
    returnEmptyString: false, // 空文字での定義を許可に
    resources: {
      en: {
        translation: require("./locales/en.json"),
      },
      ja: {
        translation: require("./locales/ja.json"),
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      // 指定したHTMLノードを翻訳時にそのまま保持して表示するための設定
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "span"],
    },
  });

export default i18n;
